import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Inject, Output } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { TagSelectionService } from 'src/services/tag-selection/tag-selection.service';
import { DetailedTag } from 'src/services/tag/DetailedTag';
import { trackByTagId } from 'src/utils/trackByTagId';
import { BottomSheetControlsComponent } from '../../app/bottom-sheet-controls/bottom-sheet-controls.component';

@Component({
  selector: 'tag-selector-bottom-sheet',
  templateUrl: 'tag-selector-bottom-sheet.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    BottomSheetControlsComponent,
  ],
})
export class TagSelectorBottomSheet {
  @Output()
  selectedTagsUpdated = new EventEmitter<DetailedTag[]>();

  trackByTagId = trackByTagId;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { detailedTags: DetailedTag[] },
    public tagSelectionService: TagSelectionService
  ) {}

  updateSelectedTags(change: MatCheckboxChange, tag: DetailedTag) {
    if (
      change.checked &&
      !this.tagSelectionService.selectedTags.includes(tag)
    ) {
      this.tagSelectionService.selectedTags.push(tag);
    } else if (
      !change.checked &&
      this.tagSelectionService.selectedTags.includes(tag)
    ) {
      this.tagSelectionService.selectedTags =
        this.tagSelectionService.selectedTags.filter((t) => t !== tag);
    }
  }

  public _bottomSheetRef =
    inject<MatBottomSheetRef<TagSelectorBottomSheet>>(MatBottomSheetRef);
}
